/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_SearchInputs */

const en_action_search = /** @type {(inputs: Action_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search`)
};

const es_action_search = /** @type {(inputs: Action_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar`)
};

const fr_action_search = /** @type {(inputs: Action_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechercher`)
};

const de_action_search = /** @type {(inputs: Action_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suchen`)
};

const ja_action_search = /** @type {(inputs: Action_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`検索`)
};

const zh_action_search = /** @type {(inputs: Action_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜索`)
};

const ar_action_search = /** @type {(inputs: Action_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بحث`)
};

const id_action_search = /** @type {(inputs: Action_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cari`)
};

const it_action_search = /** @type {(inputs: Action_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerca`)
};

const ru_action_search = /** @type {(inputs: Action_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Найти`)
};

const pt_action_search = /** @type {(inputs: Action_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesquisar`)
};

const ko_action_search = /** @type {(inputs: Action_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`검색`)
};

/**
* | output |
* | --- |
* | "Search" |
*
* @param {Action_SearchInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const action_search = /** @type {((inputs?: Action_SearchInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_SearchInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_action_search(inputs)
	if (locale === "es") return es_action_search(inputs)
	if (locale === "fr") return fr_action_search(inputs)
	if (locale === "de") return de_action_search(inputs)
	if (locale === "ja") return ja_action_search(inputs)
	if (locale === "zh") return zh_action_search(inputs)
	if (locale === "ar") return ar_action_search(inputs)
	if (locale === "id") return id_action_search(inputs)
	if (locale === "it") return it_action_search(inputs)
	if (locale === "ru") return ru_action_search(inputs)
	if (locale === "pt") return pt_action_search(inputs)
	return ko_action_search(inputs)
});